export default function ({ store, $sentry }) {
  if ($sentry?.configureScope) {
    $sentry.configureScope(function (scope) {
      scope.setUser({
        email: store.state.user.email,
        id: store.state.user.id,
      })
    })
  }
}
